import React from 'react'
import Gallery from '../components/home/Gallery'
import Heading from "../components/common/Heading";

function GalleryPage() {
  return (
   <>
    <Heading heading="Gallery" title="Home" subtitle="Gallery" />
    <Gallery/>
   </>
  )
}

export default GalleryPage
